export const boardArchivedTasksTour = {
  key: "boardArchivedTasks",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-archived-list"]',
      content: t("Tour_BoardArchivedTasks_List"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-archived-filter"]',
      content: t("Tour_BoardArchivedTasks_Filter"),
      placement: "bottom",
    },
  ],
};
